require('./ansible_credentials/adjust_on_reset.js');
require('./autofocus.js');
require('./checkchange.js');
require('./configuration/all_time_check.js');
require('./configuration/min_time_check.js');
require('./configuration/some_time_check.js');
require('./datetimepicker.js');
require('./detect_spaces.js');
require('./form_changed.js');
require('./greater_or_zero.js');
require('./greater_than_zero.js');
require('./hostname_validation.js');
require('./miq_datepicker.js');
require('./miq_form.js');
require('./miqrequired.js');
require('./reconfigure/validateMultiple.js');
require('./reconfigure/validateTotal.js');
require('./require_file.js');
require('./required_depends_on.js');
require('./scheduler/updateDropdownForFilter.js');
require('./scheduler/updateDropdownForTimer.js');
require('./selectpickerForSelectTag.js');
require('./translate.js');
require('./url_validation.js');
require('./validation/adjust_error_on_tab.js');
require('./validation/error_on_tab.js');
require('./validation/reset_validation_status.js');
require('./validation/validation_status.js');
